import { useEffect, useState } from 'react'
import { api } from '../lib/api'
import { useAuth } from '../hooks/useAuth'

export default function ProfilePage() {
  const { user } = useAuth()
  const [profile, setProfile] = useState<any>(null)
  const [editing, setEditing] = useState(false)
  const [form, setForm] = useState({ currentWeight: '', goalWeight: '', heightInches: '', bio: '' })

  useEffect(() => {
    api.getProfile().then(({ profile }) => {
      setProfile(profile)
      if (profile) {
        setForm({
          currentWeight: profile.currentWeight?.toString() || '',
          goalWeight: profile.goalWeight?.toString() || '',
          heightInches: profile.heightInches?.toString() || '',
          bio: profile.bio || '',
        })
      }
    }).catch(() => {})
  }, [])

  async function handleSave(e: React.FormEvent) {
    e.preventDefault()
    try {
      const data: any = {}
      if (form.currentWeight) data.currentWeight = parseFloat(form.currentWeight)
      if (form.goalWeight) data.goalWeight = parseFloat(form.goalWeight)
      if (form.heightInches) data.heightInches = parseFloat(form.heightInches)
      data.bio = form.bio

      await api.updateProfile(data)
      setEditing(false)
      api.getProfile().then(({ profile }) => setProfile(profile))
    } catch (err: any) {
      alert(err.message)
    }
  }

  return (
    <div>
      <div className="page-header">
        <h2>Player Profile</h2>
        <p>{user?.email}</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-value">{user?.level || 1}</div>
          <div className="stat-label">Level</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{(user?.xp || 0).toLocaleString()}</div>
          <div className="stat-label">XP</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{user?.streak || 0}</div>
          <div className="stat-label">Streak</div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <span className="card-title">Profile Info</span>
          <button className="btn btn-secondary" onClick={() => setEditing(!editing)} style={{ padding: '0.4rem 0.8rem', fontSize: '0.8rem' }}>
            {editing ? 'Cancel' : 'Edit'}
          </button>
        </div>

        {editing ? (
          <form onSubmit={handleSave}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '0.75rem' }}>
              <div className="form-group">
                <label className="form-label">Current Weight (lbs)</label>
                <input type="number" step="0.1" className="form-input" value={form.currentWeight} onChange={e => setForm(prev => ({ ...prev, currentWeight: e.target.value }))} />
              </div>
              <div className="form-group">
                <label className="form-label">Goal Weight (lbs)</label>
                <input type="number" step="0.1" className="form-input" value={form.goalWeight} onChange={e => setForm(prev => ({ ...prev, goalWeight: e.target.value }))} />
              </div>
              <div className="form-group">
                <label className="form-label">Height (inches)</label>
                <input type="number" step="0.5" className="form-input" value={form.heightInches} onChange={e => setForm(prev => ({ ...prev, heightInches: e.target.value }))} />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Bio</label>
              <input type="text" className="form-input" placeholder="Tell us about your fitness journey..." value={form.bio} onChange={e => setForm(prev => ({ ...prev, bio: e.target.value }))} />
            </div>
            <button type="submit" className="btn btn-primary">Save Profile</button>
          </form>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
            <div>
              <div className="form-label">Name</div>
              <p>{user?.displayName || `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || 'Not set'}</p>
            </div>
            <div>
              <div className="form-label">Current Weight</div>
              <p>{profile?.currentWeight ? `${profile.currentWeight} lbs` : 'Not set'}</p>
            </div>
            <div>
              <div className="form-label">Goal Weight</div>
              <p>{profile?.goalWeight ? `${profile.goalWeight} lbs` : 'Not set'}</p>
            </div>
            <div>
              <div className="form-label">Height</div>
              <p>{profile?.heightInches ? `${Math.floor(profile.heightInches / 12)}'${Math.round(profile.heightInches % 12)}"` : 'Not set'}</p>
            </div>
            {profile?.bio && (
              <div style={{ gridColumn: '1 / -1' }}>
                <div className="form-label">Bio</div>
                <p>{profile.bio}</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
